import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getCopyDashboard} from '../../../apis/analysis/getCopyDashboard'

const useQueryCopyDashboard = (limit: number, dataType: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getCopyDashboard(limit, dataType),
        queryFn: async () => {
            const {data} = await getCopyDashboard(limit, dataType)
            return data
        },
    })

    return {data, refetch}
}

export default useQueryCopyDashboard
